import { ChangeDetectorRef, Directive, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { V2AuthConfirmationAbstract } from '@app/+login/deprecated-hybrid/components/v2-auth-confirmation.abstract.component';
import storage from 'local-storage-fallback';
import { LoginService } from '@app/+login/login.service';
import { LOGIN_ID_STORAGE_ITEM_KEY } from '@app/+login/deprecated-hybrid/consts';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class V2LoginConfirmationAbstract extends V2AuthConfirmationAbstract implements OnInit {
  public hasError: boolean;

  protected constructor(private loginService: LoginService, cdr: ChangeDetectorRef, router: Router, route: ActivatedRoute) {
    super(router, route, cdr);
  }

  protected onError(): void {
    this.hasError = true;
    this.cdr.detectChanges();
  }

  protected onSuccess(): void {
    storage.removeItem(LOGIN_ID_STORAGE_ITEM_KEY);
    this.loginService.afterSignedIn(this.route.parent);
  }

  protected setupStateData(): void {
    super.setupStateData();
    // return to login page when page opened manually
    if (!this.identifier) { this.router.navigate(['..'], { relativeTo: this.route }); }
  }
}
